import { render, staticRenderFns } from "./PrepareText.vue?vue&type=template&id=040ff4ec&"
import script from "./PrepareText.vue?vue&type=script&lang=js&"
export * from "./PrepareText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports